import instance from "@/services/api";
import { buildingSettingsAPI } from "@/views/BuildingSettings/services/api";

export const projectLimitsAPI = {
  async getSbsProjects() {
    return await instance()
      .get("/common/sbs_projects/read/")
      .then((res) => res?.data);
  },
  async getProjectTypes() {
    return await buildingSettingsAPI.getProjectTypes();
  },
  async getSbsProjectMaterialLimits(project_type_id, sbs_project_id) {
    if (!project_type_id || !sbs_project_id) return;
    return await instance()
      .get("/handbook/sbs_project/materials/limit/read/", {
        params: { project_type_id, sbs_project_id },
      })
      .then((res) => res?.data);
  },
  async addSbsProjectMaterialLimit(project_type_id, sbs_project_id, body) {
    if (!project_type_id || !sbs_project_id) return;
    const payload = { ...body, project_type_id, sbs_project_id };
    return await instance()
      .post("/handbook/sbs_project/materials/limit/modify/", payload, {
        params: { project_type_id, sbs_project_id },
      })
      .then((res) => res?.data);
  },
  async updateSbsProjectMaterialLimit(
    project_type_id,
    sbs_project_id,
    body
  ) {
    if (!project_type_id || !sbs_project_id) return;
    return await instance()
      .post("/handbook/sbs_project/materials/limit/modify/", body, {
        params: { project_type_id, sbs_project_id },
      })
      .then((res) => res?.data);
  },
  async deleteSbsProjectMaterialLimit(
    project_type_id,
    sbs_project_id,
    limit_id
  ) {
    if (!project_type_id || !sbs_project_id || !limit_id) return;
    return await instance()
      .delete(
        `/handbook/sbs_project/materials/limit/id/${limit_id}/delete/`,
        { params: { project_type_id, sbs_project_id } }
      )
      .then((res) => res?.data);
  },
  async fillSbsProjectMaterialLimits(project_type_id, sbs_project_id) {
    if (!project_type_id || !sbs_project_id) return;
    return await instance()
      .post(
        "/handbook/sbs_project/materials/limit/fill/",
        { project_type_id, sbs_project_id },
        { params: { project_type_id, sbs_project_id } }
      )
      .then((res) => res?.data);
  },
};
